import { Text } from "@chakra-ui/react";
import React from "react";

function Loading(){
    return(
        <Text color={'orange'}>ローディング...</Text>
    )
}

export default Loading;